import { useMutation } from '@apollo/client'

import { gql } from '@web/gql'

const sentReviewGroupIds = new Set<string>()

const useIncreaseReviewGroupsView = () => {
  const [increase] = useMutation(
    gql(`
      mutation IncreaseReviewGroupsView($IncreaseReviewGroupsViewInput: IncreaseReviewGroupsViewInput!) {
        increaseReviewGroupsView(input: $IncreaseReviewGroupsViewInput) {
          __typename
        }
      }
    `),
  )

  const increaseReviewGroupsView = (reviewGroupIds: string[]) => {
    const willSendIds = reviewGroupIds.filter(id => !sentReviewGroupIds.has(id))
    if (willSendIds.length === 0) return

    increase({
      variables: { IncreaseReviewGroupsViewInput: { ids: willSendIds } },
      onCompleted: () => {
        willSendIds.forEach(id => sentReviewGroupIds.add(id))
      },
    })
  }

  return increaseReviewGroupsView
}

export default useIncreaseReviewGroupsView
